import React from 'react';

import { VariantNode } from '@candu-ai/styleguide/types';
import { Variants } from 'craft/containers/Toolbox/components';
import { useMultiNodes } from 'craft/hooks';

interface Props {
  nodeIds: string[];
}

export const VariantsSelectorToolbox = ({ nodeIds }: Props) => {
  const {
    props,
    type,
    actions: { setProps },
  } = useMultiNodes(nodeIds);
  return (
    <Variants
      name={props.variant?.value || 'base'}
      componentName={type}
      onSelectVariant={(variant: VariantNode) =>
        setProps({
          variant: variant.conditions.variant,
        })
      }
      conditions={props.variant?.value ? { variant: props.variant.value } : {}}
    />
  );
};
